import {addressStateValidate} from './addressStateValidate';
$(function (){
    $.validator.setDefaults({
        errorElement: "div",
        errorPlacement: function (error, element){
            // Add the `help-block` class to the error element
            error.addClass("help-block invalid-feedback");
            // error.insertAfter(element);
            if(element.attr('type') == "search"){
                error.insertAfter(element.parent());
            }
            else{
                error.insertAfter(element);
            }
        },
        highlight: function (element, errorClass, validClass){
            $(element)
                .parents(".form-group")
                .addClass("has-error")
                .removeClass("has-success");
        },
        unhighlight: function (element, errorClass, validClass){
            $(element)
                .parents(".form-group")
                .addClass("has-success")
                .removeClass("has-error");
        },
    });
    $.validator.addMethod("addressZip", function(this:any,value, element) {
       
        var afterCom =window.location.href.split('.com')[1];
        var isWebSite =  afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? "ca" : "us";
        
        if (isWebSite == 'ca'){
            return this.optional( element ) || /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(value);
        }
        else{
            return this.optional( element ) || /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
        }
    
    }, 'Invalid ZIP/Postal Code');

    $.validator.addMethod("email", function (this: any, value, element)
    {
        return this.optional(element) || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
    }, 'Please enter a valid email address');
    
    $.validator.addMethod("noSpace", function(value, element) { 
        return value == '' || value.trim().length != 0;  
    }, "Space not allowed");
    
$(".personal-info-form").validate({
    onkeyup:function(this:any,element){
     if($(element).val() !=""){
        $(element).valid();
      }
      var checkeForm = this.checkForm();
      if(checkeForm){
        $("#contact-information-screen .next").removeClass("disble-btn");
        $("#contact-information-screen .next").prop("disabled", false);
      }else{
        $("#contact-information-screen .next").addClass("disble-btn");
        $("#contact-information-screen .next").prop("disabled", true);
      }
    },
    rules: {
        firstname : {
            required: true,
            noSpace: true
        },
        lastname: {
            required: true,
            noSpace: true
        },
        email: {
            required: true,
            email: true,
        },
        phonenumber: {
            required: true,
            minlength: 14,
            maxlength: 14,
        },
    },
    messages: {
        phonenumber: "Please enter a valid phone number",
    },
});
$("#service-address").validate({
    onkeyup:function(this:any,element){
        if($(element).val() !=""){
            $(element).valid();
        }
        var checkeForm = this.checkForm();
        if(checkeForm && addressStateValidate()){
          $("#service-address-screen .next").removeClass("disble-btn");
          $("#service-address-screen .next").prop("disabled", false);
        }else{
          $("#service-address-screen .next").addClass("disble-btn");
          $("#service-address-screen .next").prop("disabled", true);
        }
    },
    rules: {
        address: {
            required: true,
            noSpace: true
        },
        address2: {
            noSpace: true
        },
        city: {
            required: true,
            noSpace: true
        },
        state: {
            required: true,
        },
    },
});
$("#service-details-form").validate({
    onfocusout:function(this:any,element){
        $(element).valid();
    },
    rules: {
        referencedetails: {
            required: true,
        }
    }
});

})